import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { postAPI } from "../backend/commons";

export const uploadSVCFile = async (file) => {
    const fileFormData = new FormData();
    fileFormData.append('svc-file', file);
    // fileFormData.append('is-approved', isApproved);
    // fileFormData.append('threshold', '10.5');
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
    }
    let apiUrl =
        localDatabaseUrls.baseURL +
        localDatabaseUrls.serviceURL.svcUploadFile

    // let fakeAPI = "https://api.escuelajs.co/api/v1/files/upload"
return postAPI(apiUrl,fileFormData,tokenInfo);
}
